import { Controller } from 'react-hook-form';
import { StyleProp, ViewStyle } from 'react-native';
import { Checkbox } from 'react-native-paper';
import { CheckboxOption } from '../crop-circle/Components/CheckboxOption';

type ControlledCheckboxItemProps = {
  control: any;
  name: string;
  label: string;
  position: 'leading' | 'trailing';
  style?: StyleProp<ViewStyle>;
  labelStyle?: StyleProp<ViewStyle>;
  mode?: 'android' | 'ios';
  disabled?: boolean;
  useCropCircle?: boolean;
};

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
const ControlledCheckboxItemOld = (props: ControlledCheckboxItemProps) => {
  return (
    <Controller
      control={props.control}
      name={props.name}
      render={({ field: { onChange, value } }) => (
        <Checkbox.Item
          style={props.style}
          labelStyle={props.labelStyle}
          label={props.label}
          position={props.position}
          status={value ? 'checked' : 'unchecked'}
          onPress={() => onChange(!value)}
          mode={props.mode}
          disabled={props.disabled}
        />
      )}
    />
  );
};

// TODO: Crop Circle Redesign | Remove to ControlledCheckboxItemBase after feature is fully rolled out
const ControlledCheckboxItemBase = (props: ControlledCheckboxItemProps) => {
  return (
    <Controller
      control={props.control}
      name={props.name}
      render={({ field: { onChange, value } }) => (
        <CheckboxOption
          mode="checkbox"
          state={value ? 'checked' : 'unchecked'}
          label={props.label}
          onPress={() => onChange(!value)}
          disabled={props.disabled}
        />
      )}
    />
  );
};

export const ControlledCheckboxItem = (props: ControlledCheckboxItemProps) => {
  if (props.useCropCircle) {
    return <ControlledCheckboxItemBase {...props} />;
  }

  return <ControlledCheckboxItemOld {...props} />;
};
